import * as React from 'react';
import { IDatePickerCalendarNavbarProps } from '../../../DatePicker.types';
import Navbar from '../../../../DatePickerCalendar/viewer/components/Navbar';
import styles from '../../../../DatePickerCalendar/viewer/styles/NavbarDefaultSkin.scss';

const NavbarDefaultSkin: React.FC<IDatePickerCalendarNavbarProps> = props => {
  return <Navbar {...props} style={styles}></Navbar>;
};

export default NavbarDefaultSkin;
